import { QUICK_LOAN_LTV } from 'constant';
import { AlchemyNFT } from 'simplehash_api/types/simpleHash';

type LoanCategoryKey = 'eligibleAssets' | 'nearEligibleAssets' | 'ineligibleAssets';

export type QuickLoanNFT = AlchemyNFT & { percentFloorPrice: number };

interface LoanCategory {
  key: LoanCategoryKey;
  description: string;
  data: QuickLoanNFT[];
}

const sortByDescendingFloor = (data: QuickLoanNFT[]) => data.toSorted((a, b) => b.percentFloorPrice - a.percentFloorPrice);

export function divideAndSortNft(items: AlchemyNFT[] | undefined, inputValue?: string | number): LoanCategory {
  const value = Number(inputValue);
  const categories: Record<LoanCategoryKey, LoanCategory> = {
    eligibleAssets: {
      key: 'eligibleAssets',
      description: 'Select an asset to borrow against. Terms are based on historical lender offers.',
      data: [],
    },
    nearEligibleAssets: {
      key: 'nearEligibleAssets',
      description: 'It looks like you don’t have any assets worth the amount you’re trying to borrow, here are some assets that come close.',
      data: [],
    },
    ineligibleAssets: {
      key: 'ineligibleAssets',
      description: 'Looks like you don’t have any assets in your wallet that can facilitate this loan request.',
      data: [],
    },
  };

  if (!items || !inputValue) return categories.ineligibleAssets;

  for (const item of items) {
    const floorPrice = item.contract?.openSeaMetadata?.floorPrice;
    const percentFloorPrice = (floorPrice * QUICK_LOAN_LTV) / 100;

    const nft = { ...item, percentFloorPrice };

    if (percentFloorPrice >= value) {
      categories.eligibleAssets.data.push(nft);
    } else {
      categories.nearEligibleAssets.data.push(nft);
    }
  }

  if (categories.eligibleAssets.data.length > 0) return { ...categories.eligibleAssets, data: sortByDescendingFloor(categories.eligibleAssets.data) };
  if (categories.nearEligibleAssets.data.length > 0) return { ...categories.nearEligibleAssets, data: sortByDescendingFloor(categories.nearEligibleAssets.data) };
  return categories.ineligibleAssets;
}
